import {routes, request} from "./"

export function createReferralSource (commit, product) {
  return request(commit, routes.referral_sources.create, product, 'post')
}

export function updateReferralSource (commit, product) {
  return request(commit, routes.referral_sources.update, product, 'post')
}

export function deleteReferralSource (commit, product) {
  return request(commit, routes.referral_sources.delete, product, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/referral_sources.js
// module id = 611
// module chunks = 0